import { Content } from '@components/Content'
import { Text } from '@components/Elements/Text'
import { ScreenLayout } from '@components/Layouts'
import { useI18n } from '@lib/i18n'
import { getRemoteFormDefinition } from '@lib/validation'
import { Route, useRoute } from '@react-navigation/native'
import { useTasksStore } from '@stores/tasks'
import { PatientTask } from '@vetahealth/tuna-can-api'
import dayjs from 'dayjs'
import { useEffect } from 'react'
import { RouteName } from 'src/router/routeNames'
import styled, { useTheme } from 'styled-components/native'

const Wrapper = styled.View`
  padding: 30px;
  padding-top: 0;
`

export function AnsweredTask() {
  const t = useI18n()
  const theme = useTheme()
  const [answeredTask, getAnsweredTask] = useTasksStore((state) => [state.answeredTask, state.getAnsweredTask])
  const { params } =
    useRoute<
      Route<RouteName.AnsweredTask, { responseId: PatientTask['responseId']; timestamp: PatientTask['timestamp'] }>
    >()

  useEffect(() => {
    if (params.responseId) {
      getAnsweredTask(params.responseId)
    }
  }, [params])

  return (
    <ScreenLayout hasBack title={t('screen.answeredTasks')}>
      <Wrapper>
        <Text size="tiny" weight="medium" margins={{ bottom: 10 }} color={theme.colors.primaryButtonText}>
          {dayjs(params.timestamp).format('LLL')}
        </Text>
        {answeredTask?.content?.['assets'] ? (
          <Content
            readOnly
            hideActions
            content={answeredTask.content}
            formDefinition={getRemoteFormDefinition(answeredTask.content.assets)}
          />
        ) : null}
      </Wrapper>
    </ScreenLayout>
  )
}
